import apiClient from '@/services/rest-api-vsms/apiClient'

const baseEndpoint = '/box-type'

export const get = async (queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: baseEndpoint,
    params: params,
  })

  return response?.data
}

export const show = async (id) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/${id}`,
  })

  return response?.data
}

export const store = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: baseEndpoint,
    data,
  })

  return response?.data
}

export const update = async (id, data) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${id}`,
    data,
  })

  return response?.data
}

export const deleteMany = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}/delete`,
    data,
  })

  return response?.data
}
